module.exports = __webpack_public_path__ + "media/src/application/media/route_2-47f652c0ed05de7fabd9d86a7e25d67b.png";